// extracted by mini-css-extract-plugin
export default {"listView":"ListView_listView__XGhdx","bodyContainer":"ListView_bodyContainer__YHYAY"};